import { getIconForIntegrationType } from '@modules/integrationsV2/utils';
import { Stack, Typography } from '@mui/material';
import { ObjectType } from 'generated/graphql';
import { capitalize } from 'lodash';
import pluralize from 'pluralize';
import { toTitleCase } from 'v2/utils/strings';

interface FeedbackDetailsMetadataCardProps {
  objectType: ObjectType;
  objectIDCount: number;
}

export const FeedbackMetadataTypeHeader = ({
  objectType,
  objectIDCount,
}: FeedbackDetailsMetadataCardProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={1}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        {getIconForIntegrationType({
          integrationType: objectType.toString(),
        })}
        <Typography
          sx={{
            color:
              ObjectType.Feedback === objectType
                ? 'feedback.label'
                : `misc.integrations.${objectType.toLowerCase()}`,
          }}
        >
          {capitalize(objectType)} Metadata
        </Typography>
      </Stack>
      {objectIDCount > 1 && (
        <Typography variant="body2" color="text.secondary">
          {objectIDCount} {pluralize(toTitleCase(objectType))}
        </Typography>
      )}
    </Stack>
  );
};
